"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenAndCloseFocus = useOpenAndCloseFocus;

var _react = require("react");

var _utils = require("@primer/behaviors/utils");

function useOpenAndCloseFocus({
  initialFocusRef,
  returnFocusRef,
  containerRef,
  preventFocusOnOpen
}) {
  (0, _react.useEffect)(() => {
    if (preventFocusOnOpen) {
      return;
    }

    const returnRef = returnFocusRef.current;

    if (initialFocusRef && initialFocusRef.current) {
      initialFocusRef.current.focus();
    } else if (containerRef.current) {
      const firstItem = (0, _utils.iterateFocusableElements)(containerRef.current).next().value;
      firstItem === null || firstItem === void 0 ? void 0 : firstItem.focus();
    }

    return function () {
      returnRef === null || returnRef === void 0 ? void 0 : returnRef.focus();
    };
  }, [initialFocusRef, returnFocusRef, containerRef, preventFocusOnOpen]);
}